import {get} from "@/plugins/request";

const prefix = '/v1/download';

export function downloadResources(productId, releaseId, resourceId) {
  return get(`${prefix}/products/${productId}/releases/${releaseId}/resources/${resourceId}`)
}
